import { useSelector } from 'react-redux';
import { UserType } from '@gumtree/shell/src/reducers/common/user-type';
import { State as PageState } from '@gumtree/shell/src/reducers/page';

export function useUserType() {
    // Avoid some pages not returning usertype in model and hydration problems
    const { cookieUserType, modelUserType } = useSelector(
        ({ page, userType }: { page: PageState; userType: UserType }) => ({
            cookieUserType: page?.userType,
            modelUserType: userType,
        })
    );
    return cookieUserType || modelUserType || 'STANDARD';
}
